// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d2c92dba","453":"07a6ab98","796":"dc8b78ff"}[chunkId] + ".chunk.js";
};